module.exports = __webpack_public_path__ + "dfccdbee5159ff9610632b8875e0ea78.svg";